module.exports = __webpack_public_path__ + "static/kohra-622b29ab9d3cd1305d5f915e6de0b8e8.jpg";